module.exports = __webpack_public_path__ + "static/media/disabledReport.11adbbbb.png";